<template>
  <div class="main-box">
    <ball></ball>
    <van-nav-bar
      title="门诊挂号清单"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
    />
    <div class="cholseDate">
      <div
        class="dateitem"
        :value="begindate"
        @click="showCalendar['begindate'] = true"
      >
        {{ begindate }}
      </div>
      <div class="dateitem_-">~</div>
      <div
        class="dateitem"
        :value="enddate"
        @click="showCalendar['enddate'] = true"
      >
        {{ enddate }}
      </div>
      <van-calendar
        color="#5b8df6"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="showCalendar['begindate']"
        @confirm="(value) => onConfirm(value, 'begindate')"
      />
      <van-calendar
        color="#5b8df6"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="showCalendar['enddate']"
        @confirm="(value) => onConfirm(value, 'enddate')"
      />
    </div>
    <div class="cell">
      <div
        class="item"
        size="large"
        v-for="(item, index) in hospitalizationList"
        :key="index"
        @click="goCarddetails(item)"
      >
        <div class="cell_item">
          <div class="title">{{ item.clientName }}</div>
          <div class="value">挂号流水号: {{ item.clinicId }}</div>
        </div>
        <div class="cell_item">
          <div class="value">{{ item.regDate }}</div>
          <div class="value">科室: {{ item.deptName }}</div>
          <!-- class="btn_mini_style" -->
          <!-- <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click.stop="query(item.medCardNo)"
              >查看</van-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <van-empty
      v-if="hospitalizationList.length === 0"
      description="暂无相关数据"
    />
    <!-- <div class="Btn_style">
      <van-button
        class="btn"
        type="info"
        size="large"
        round
        @click.stop="$router.push('/hospitalization_C_byNo')"
        text="通过住院号查询"
      >
      </van-button>
    </div> -->
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
import backindex from '@/mixins/backindex'
export default {
  mixins: [setOptions,backindex],
  data() {
    return {
      showCalendar: {
        begindate: false,
        enddate: false,
      },
      begindate: new Date(),
      enddate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2040, 0, 1),
      navTitle: "就诊卡列表",
      hospitalizationList: [],
      isLoad: true,
      clientId: "",
      test: { a: 0.01 },
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.enddate = this.getyDay(this.enddate);
    this.begindate = this.getLmDay(this.begindate);
    if (this.$route.query) {
      console.log(this.$route.query);
      this.clientId = this.$route.query.clientId;
      this.name = this.$route.query.name;
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.$router.push("/patient_card_confUser_C");
      return;
    }

    this.gethospitalization();
  },
  created() {
    // console.log((this.test['a']) == 'string'&&this.test['a'].indexOf(".000Z")==-1)
  },
  methods: {
    //获取昨天
    getyDay(date) {
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 10);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //获取上个月
    getLmDay(date) {
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 30);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //选择日期
    onConfirm(value, type) {
      //  console.log(new Date(value))
      this[type] = this.formatDate(new Date(value));
      this.showCalendar[type] = false;
      this.gethospitalization();
    },
    //
    onClickLeft() {
      this.$router.push("/index");
    },
    //
    //跳转详情页
    goCarddetails(item) {
      console.log("item:::",item);
      this.$router.push({
        path: "/outpatientFeeList_detail_C",
        query: {
          invoiceNo: item.clinicId,
        },
      });
    },

    async gethospitalization() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/registerRecord";
        // medCardNo=00000522&start_date=2020-01-10 00:00:00&end_date=2021-01-26 00:00:00
        let data = {
          // medCardNo: "00004462",
          start_date: this.begindate,
          end_date: this.enddate,
          medCardNo:this.clientId
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (resultdata) => {
            this.$hideLoad();
            if (resultdata && resultdata.data) {
              this.hospitalizationList = resultdata.data;
            }
            console.log(this.hospitalizationList);
            // Dialog.alert({
            //   message:
            //     "该公众号目前数据均为测试数据，你所录入的数据也将录入测试数据",
            // }).then(() => {
            //   // on close
            // });
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background: white;

  .nav {
    margin-bottom: 8px;
  }
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    .cell_item {
      display: flex;
      flex-direction: row;
      line-height: 40px;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 10px;
      .title {
        font-size: 18px;
        color: #323233;
      }
      .value {
        font-size: 16px;
        color: #555;
      }
      .label {
        font-size: 15px;
        color: #999;
      }
    }
    // margin-top: 15px;
  }
  .item {
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 16px;
    &::after {
      border-bottom: 0;
    }
    margin-bottom: 15px;
    background-color: #f7f8fa;
    box-shadow: 0 8px 12px #ebedf0;
    border-radius: 8px;
  }

  .btn-box {
    .btn {
      margin-left: 40px;
    }
  }
}
.cell_box {
  display: flex;
  flex-direction: column;
}
.mar {
  margin-top: 10px;
}
.submit {
  margin: 55px 20px 25px 20px;
}
.Btn_style {
  width: 100%;
  // margin: 0px auto;
  position: fixed;
  bottom: 0vh;
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-items: center;
  height: 70px;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .btn {
    width: 95%;
    letter-spacing: 10px;
    font-size: 16px;
    margin: 10px auto;
    background-color: #5b8df6;
  }
}
.btn_mini_style {
  width: 80px;
  height: 25px;
  letter-spacing: 7px;
}
.van-button--round {
  border-radius: 10px;
}
.main-box {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top {
    height: 50px;
  }
.cholseDate {
    widows: 90%;
    display: flex;
    margin: 0px auto;
    margin-top: 10px;
    .dateitem_- {
      margin-left: 20px;
      color: #95a5a6;
    }
    .dateitem {
      margin-left: 20px;
      color: #95a5a6;
      border-bottom: 1px solid #95a5a6;
    }
  }
}
</style>